import $ from 'jquery';
import { CHANGE_SCHEDULE_VIEW } from 'common/actions';

function schedule(state = {}, action) {
  const newState = $.extend(true, {}, state);
  switch (action.type) {
  // Actions around following the team
  case CHANGE_SCHEDULE_VIEW:
    newState.view = action.payload.view;
    break;
  default:
    return state;
  }
  return newState;
}

export default schedule;
